import { Inject, Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { tap, shareReplay, catchError } from 'rxjs/operators';
// import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Injectable({ 
  providedIn: 'root'
})

export class SupersetDashboardService {

  public isOpen: boolean = false;
  public isGlobalSearchShow:boolean=false;
  public isSearchShow:boolean = false;
  public isLoading: boolean = false;

  // Cache for superset dashboard submenu
  private supersetSubMenuCache$: Observable<any> | null = null;
  private cachedSubMenuData: any[] = [];
  private isCacheLoaded: boolean = false;

  constructor(
    private apiRequest: ApiRequestService,
    public notifier: NotifierService,
    private router: Router,
    
  ) { }

  getAuthGuestToken(body: any): Observable<any> {
    return this.apiRequest.request('POST', `/v2/superset-dash/guest-token`, body);
  }

  /**
   * Get superset sub menu dashboards with caching.
   * API is called only once and result is cached for subsequent calls.
   */
  getSuperSetSubMenuDash(): Observable<any> {
    // If data is already cached, return it immediately
    if (this.isCacheLoaded && this.cachedSubMenuData.length > 0) {
      return of({ status: true, data: this.cachedSubMenuData });
    }

    // If request is in flight, return the same observable
    if (!this.supersetSubMenuCache$) {
      this.supersetSubMenuCache$ = this.apiRequest.request('GET', `/v2/superset-dash/all`).pipe(
        tap((res: any) => {
          if (res && res.status && res.data && res.data.length > 0) {
            this.cachedSubMenuData = res.data;
            this.isCacheLoaded = true;
          }
        }),
        shareReplay(1),
        catchError((error) => {
          this.supersetSubMenuCache$ = null; // Reset cache on error to allow retry
          throw error;
        })
      );
    }

    return this.supersetSubMenuCache$;
  }

  /**
   * Get cached submenu data synchronously (if already loaded)
   */
  getCachedSubMenuData(): any[] {
    return this.cachedSubMenuData;
  }

  /**
   * Check if cache is loaded
   */
  isCacheReady(): boolean {
    return this.isCacheLoaded;
  }

  /**
   * Clear cache (useful for refresh scenarios)
   */
  clearCache(): void {
    this.supersetSubMenuCache$ = null;
    this.cachedSubMenuData = [];
    this.isCacheLoaded = false;
  }
}